/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FaqDto } from '../../models/faq-dto';

export interface FaqControllerFindAll$Params {
}

export function faqControllerFindAll(http: HttpClient, rootUrl: string, params?: FaqControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FaqDto>>> {
  const rb = new RequestBuilder(rootUrl, faqControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FaqDto>>;
    })
  );
}

faqControllerFindAll.PATH = '/api/v1/faq';
